// extracted by css-extract-rspack-plugin
export default {"segmentedBar":"KzzntktDysT4tzxU","segment":"LPk8rC07LzENuphd"};